module.exports = __webpack_public_path__ + "static/media/upload_file.66e3107e.svg";